import React from "react";
import { Helmet } from "react-helmet";
import { useI18n } from "@core/i18n/i18n";

export const Metadata: React.FC = () => {
	const { format } = useI18n();

	return (
		<Helmet>
			<title>{format("metadata.title")}</title>
		</Helmet>
	);
};
